<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row">
                <div class="col-lg-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Update module <span style="text-transform: lowercase;">A</span>nd
                                weeks</h4>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group label="Module Name:" label-for="ModuleName">
                                        <b-form-input type="text" id="ModuleName" name="ModuleName"
                                            autocomplete="ModuleName" v-model="$v.form.ModuleName.$model"
                                            :state="$v.form.ModuleName.$dirty ? !$v.form.ModuleName.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Module Number:" label-for="ModuleNumber">
                                        <b-form-input type="text" id="ModuleNumber" name="ModuleNumber"
                                            autocomplete="ModuleNumber" v-model="$v.form.ModuleNumber.$model"
                                            :state="$v.form.ModuleNumber.$dirty ? !$v.form.ModuleNumber.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Module Start Date:" label-for="ModuleStartDate">
                                        <b-form-input type="date" id="ModuleStartDate" name="ModuleStartDate"
                                            autocomplete="ModuleStartDate" v-model="form.ModuleStartDate"
                                            :state="$v.form.ModuleStartDate.$dirty ? !$v.form.ModuleStartDate.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Module End Date:" label-for="ModuleEndDate">
                                        <b-form-input type="date" id="ModuleEndDate" name="ModuleEndDate"
                                            autocomplete="ModuleEndDate" v-model="form.ModuleEndDate"
                                            :state="$v.form.ModuleEndDate.$dirty ? !$v.form.ModuleEndDate.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Module Start Time:" label-for="ModuleStartTime">
                                        <input type="time" v-model="form.ModuleStartTime">
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Module End Time:" label-for="ModuleEndTime">
                                        <input type="time" v-model="form.ModuleEndTime">
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Seminar Start Time:" label-for="SeminarStartTime">
                                        <input type="time" v-model="form.SeminarStartTime">
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Seminar End Time:" label-for="SeminarEndTime">
                                        <input type="time" v-model="form.SeminarEndTime">
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Module Venue:" label-for="ModuleVenue">
                                        <b-form-input type="text" id="ModuleVenue" name="ModuleVenue"
                                            autocomplete="ModuleVenue" v-model="$v.form.ModuleVenue.$model"
                                            :state="$v.form.ModuleVenue.$dirty ? !$v.form.ModuleVenue.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Venue Address 1:" label-for="ModuleAddress1">
                                        <b-form-input type="text" id="ModuleAddress1" name="ModuleAddress1"
                                            autocomplete="ModuleAddress1" v-model="$v.form.ModuleAddress1.$model"
                                            :state="$v.form.ModuleAddress1.$dirty ? !$v.form.ModuleAddress1.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Venue Address 2:" label-for="ModuleAddress2">
                                        <b-form-input type="text" id="ModuleAddress2" name="ModuleAddress2"
                                            autocomplete="ModuleAddress2" v-model="$v.form.ModuleAddress2.$model"
                                            :state="$v.form.ModuleAddress2.$dirty ? !$v.form.ModuleAddress2.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Venue City:" label-for="ModuleCity">
                                        <b-form-input type="text" id="ModuleCity" name="ModuleCity"
                                            autocomplete="ModuleCity" v-model="$v.form.ModuleCity.$model"
                                            :state="$v.form.ModuleCity.$dirty ? !$v.form.ModuleCity.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Venue State:" label-for="ModuleState">
                                        <b-form-input type="text" id="ModuleState" name="ModuleState"
                                            autocomplete="ModuleState" v-model="$v.form.ModuleState.$model"
                                            :state="$v.form.ModuleState.$dirty ? !$v.form.ModuleState.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-6">
                                    <b-form-group label="Venue Zip:" label-for="ModuleZip">
                                        <b-form-input type="text" id="ModuleZip" name="ModuleZip"
                                            autocomplete="ModuleZip" v-model="$v.form.ModuleZip.$model"
                                            :state="$v.form.ModuleZip.$dirty ? !$v.form.ModuleZip.$error : null"
                                            aria-describedby="input-1-live-feedback">
                                        </b-form-input>
                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                            field.
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-12">
                                    <b-form-group label="Venue Map:" label-for="ReferralNotes">
                                        <ckeditor id="ReferralNotes" class="textarea-referral" v-model="form.ModuleMap"
                                            rows="3" max-rows="12" :config="editorConfig">
                                        </ckeditor>
                                    </b-form-group>
                                </div>
                                <div class="col-md-12">
                                    <label for="TextBox1" class="d-block">Module Description</label>
                                    <div>
                                        <ckeditor id="TextBox1" v-model="form.ModuleDescription" :config="editorConfig1">
                                        </ckeditor>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label for="TextBox1" class="d-block">Module Content</label>
                                    <div>
                                        <ckeditor id="TextBox1" v-model="form.ModuleContent" :config="editorConfig2">
                                        </ckeditor>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="card-body">
                                <div class="row" v-for="(items, index) in weekModule" :key="items.id">
                                    <div class="col-md-6">
                                        <b-form-group :label="'Week ' + (index + 1) + ' Name:'"
                                            :label-for="'WeekName' + items.WeekID">
                                            <b-form-input type="text" :id="'WeekName' + items.WeekID"
                                                :name="'WeekName' + items.WeekID"
                                                :autocomplete="'WeekName' + items.WeekID" v-model="items.WeekName"
                                                :aria-describedby="'input-1-live-feedback' + items.WeekID">
                                            </b-form-input>
                                            <b-form-invalid-feedback :id="'input-1-live-feedback' + items.WeekID">This
                                                is a
                                                required field.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-6">
                                        <b-form-group :label="'Week ' + (index + 1) + ' Description:'"
                                            :label-for="'WeekDescription' + items.WeekID">
                                            <b-form-input type="text" :id="'WeekDescription' + items.WeekID"
                                                :name="'WeekDescription' + items.WeekID"
                                                :autocomplete="'WeekDescription' + items.WeekID"
                                                v-model="items.WeekDescription"
                                                :aria-describedby="'input-1-live-feedback' + items.WeekID">
                                            </b-form-input>
                                            <b-form-invalid-feedback :id="'input-1-live-feedback' + items.WeekID">This
                                                is a
                                                required field.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>

                                    <div class="col-md-3">
                                        <b-form-group :label="'Week ' + (index + 1) + ' Start Date:'"
                                            :label-for="'WeekStartDate' + items.WeekID">
                                            <b-form-input type="date" :id="'WeekStartDate' + items.WeekID"
                                                :name="'WeekStartDate' + items.WeekID"
                                                :autocomplete="'WeekStartDate' + items.WeekID"
                                                v-model="items.WeekStartDate"
                                                :aria-describedby="'input-1-live-feedback' + items.WeekID">
                                            </b-form-input>
                                            <b-form-invalid-feedback :id="'input-1-live-feedback' + items.WeekID">This
                                                is a
                                                required field.</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group :label="'Week ' + (index + 1) + ' End Date:'"
                                            :label-for="'WeekEndDate' + items.WeekID">
                                            <b-form-input type="date" :name="'WeekEndDate' + items.WeekID"
                                                v-model="items.WeekEndDate">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group :label="'Week ' + (index + 1) + ' Start Time:'"
                                            :label-for="'WeekStartTime' + items.WeekID">
                                            <input type="time" v-model="items.WeekStartTime"
                                                :name="'WeekStartTime' + items.WeekID">
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-3">
                                        <b-form-group :label="'Week ' + (index + 1) + ' End Time:'"
                                            :label-for="'WeekEndTime' + items.WeekID">
                                            <input type="time" v-model="items.WeekEndTime"
                                                :name="'WeekEndTime' + items.WeekID">
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-md-6"></div>
                                <div class="col-md-6 mt-3">
                                    <b-button type="submit" variant="success" :disabled="isDisabled"
                                        class="btn float-right btn-success">
                                        <span v-if="!this.form.id">Submit</span>
                                        <span v-if="this.form.id">Update</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import CKEditor from 'ckeditor4-vue';
import moment from 'moment'
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";


Vue.use(CKEditor)
export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            WeekStartTime: [],
            form: {
                id: '',
                ModuleName: '',
                ModuleNumber: '',
                ModuleStartDate: '',
                ModuleEndDate: '',
                ModuleStartTime: '',
                ModuleEndTime: '',
                SeminarStartTime: '',
                SeminarEndTime: '',
                ModuleVenue: '',
                ModuleAddress1: '',
                ModuleAddress2: '',
                ModuleCity: 0,
                ModuleState: 0,
                ModuleZip: 0,
                ModuleMap: '',
                ModuleDescription: '',
                ModuleContent: '',
                WeekName: '',
                WeekDescription: '',
                WeekStartDate: '',
                WeekEndDate: '',
                weeks: ''
            },

            isDisabled: false,
            readonly: true,
            module: {},
            weekModule: [],
            editorConfig: {
                versionCheck: false
            },
            editorConfig1: {
                versionCheck: false
            },
            editorConfig2: {
                versionCheck: false
            },
        };
    },
    validations: {
        form: {

            ModuleName: {
                required,
            },
            ModuleNumber: {
                required,
            },
            ModuleStartDate: {
                required,
            },
            ModuleEndDate: {
                required,
            },
            ModuleStartTime: {
                required,
            },
            ModuleEndTime: {
                required,
            },
            SeminarStartTime: {
                required,
            },
            SeminarEndTime: {
                required,
            },
            ModuleVenue: {
                required,
            },
            ModuleAddress1: {
                required,
            },
            ModuleAddress2: {
                required,
            },
            ModuleCity: {
                required,
            },
            ModuleState: {
                required,
            },
            ModuleZip: {
                required,
            },
        }
    },
    mounted() {
        if (this.$route.params.id && this.$route.params.id !== undefined) {
            this.form.id = this.$route.params.id;
            this.readonly = true;

        } else {
            this.readonly = false;
        }
        this.editModule();
    },
    methods: {
        onSubmit() {
            this.isDisabled = true;
            this.form.weeks = this.weekModule;
            API.updateModule(this.form,
                data => {
                    this.isDisabled = false;
                    if (!this.form.id) {
                        if (data.status === 410) {
                            this.$showNotification(data, "error")
                        } else {
                            this.$showNotification(data, "success")
                            // this.$router.push({ name: 'ViewModules' })
                        }
                    } else {
                        if (data.status === 200) {
                            this.$showNotification(data, "success")
                            // this.$router.push({ name: 'ViewModules' })
                        } else {
                            this.$showNotification({ message: 'Please try again.' }, "error")
                        }
                    }
                },
                err => {
                    this.isDisabled = false;
                    console.log(err);
                    this.$showNotification({ message: 'Failed system error' }, "error")
                }
            )
        },

        editModule() {
            if (this.$route.params.module) {
                this.module = this.$route.params.module;
                this.form.id = this.module.ModuleID;
                this.form.ModuleName = this.module.ModuleName;
                this.form.ModuleNumber = this.module.ModuleNumber;
                this.form.ModuleStartDate = moment(this.module.ModuleStartDate).format('y-MM-DD');
                this.form.ModuleEndDate = moment(this.module.ModuleEndDate).format('y-MM-DD');
                this.form.ModuleStartTime = moment(this.module.ModuleStartTime).format('hh:mm');
                this.form.ModuleEndTime = moment(this.module.ModuleEndTime).format('hh:mm');
                this.form.SeminarStartTime = moment(this.module.SeminarStartTime).format('hh:mm');
                this.form.SeminarEndTime = moment(this.module.SeminarEndTime).format('hh:mm');
                this.form.ModuleVenue = this.module.ModuleVenue;
                this.form.ModuleAddress1 = this.module.ModuleAddress1;
                this.form.ModuleAddress2 = this.module.ModuleAddress2;
                this.form.ModuleCity = this.module.ModuleCity;
                this.form.ModuleState = this.module.ModuleState;
                this.form.ModuleZip = this.module.ModuleZip;
                this.form.ModuleMap = this.module.ModuleMap;
                this.form.ModuleDescription = this.module.ModuleDescription;
                this.form.ModuleContent = this.module.ModuleContent;
                // this.weekModule = this.module.weeks;
                this.weekModule = this.module.weeks.map(week => ({
                    ...week,
                    WeekStartDate: moment(week.WeekStartDate).format('y-MM-DD'),
                    WeekEndDate: moment(week.WeekEndDate).format('y-MM-DD'),
                    WeekStartTime: moment(week.WeekStartTime).format('hh:mm'),
                    WeekEndTime: moment(week.WeekEndTime).format('hh:mm'),
                }));
            } else {
                this.$router.push({ name: 'ViewModules' });
            }
        },

    },
    computed: {
        formattedTime: {
            get() {
                // Extract the hours and minutes from the original value
                const [hours, minutes] = this.form.ModuleStartTime.split(':');
                // Return the formatted time without seconds and AM/PM
                return `${hours}:${minutes}`;
            },
            set(newValue) {
                // Update the original value with the new formatted time
                this.form.ModuleStartTime = newValue;
            }
        },
        formattedTimeModuleEndTime: {
            get() {
                // Extract the hours and minutes from the original value
                const [hours, minutes] = this.form.ModuleEndTime.split(':');
                // Return the formatted time without seconds and AM/PM
                return `${hours}:${minutes}`;
            },
            set(newValue) {
                // Update the original value with the new formatted time
                this.form.ModuleEndTime = newValue;
            }
        },
        formattedSeminarStartTime: {
            get() {
                // Extract the hours and minutes from the original value
                const [hours, minutes] = this.form.SeminarStartTime.split(':');
                // Return the formatted time without seconds and AM/PM
                return `${hours}:${minutes}`;
            },
            set(newValue) {
                // Update the original value with the new formatted time
                this.form.SeminarStartTime = newValue;
            }
        },
        formattedSeminarEndTime: {
            get() {
                // Extract the hours and minutes from the original value
                const [hours, minutes] = this.form.SeminarEndTime.split(':');
                // Return the formatted time without seconds and AM/PM
                return `${hours}:${minutes}`;
            },
            set(newValue) {
                // Update the original value with the new formatted time
                this.form.SeminarEndTime = newValue;
            }
        },

        formattedTimeWeekStartTime: {
            get() {
                return this.weekModule.map(item => {
                    const [hours, minutes] = item.WeekStartTime.split(':');
                    return `${hours}:${minutes}`;
                });
            },
            set(newValue) {
                this.weekModule = newValue.map(time => ({ WeekStartTime: time }));
            }
        },
        formattedTimeWeekEndTime: {
            get() {
                return this.weekModule.map(item => {
                    const [hours, minutes] = item.WeekEndTime.split(':');
                    return `${hours}:${minutes}`;
                });
            },
            set(newValue) {

                this.weekModule = newValue.map(time => ({ WeekEndTime: time }));
            }
        }
    },
}
</script>
